import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Col, Container, Form, Row, Tabs, Tab } from 'react-bootstrap';

import styles from './BreedingPageConfig.module.scss';
import { useTranslate } from 'react-polyglot';
import { useAuth } from '../../../Auth';
import { useAxios } from '../../../AxiosHandler';
import Card from '../../Shared/Card/Card';
import { general } from '../../../general';

function BreedingPageConfig(props: BreedingPageConfigProps) {
    const t = useTranslate();
    const navigate = useNavigate();
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const [columns, setColumns] = React.useState<any | undefined>();
    // const [externalColumns, setExternalColumns] = React.useState<any | undefined>();
    // const [breedingColumns, setBreedingColumns] = React.useState<any | undefined>();
    // //const [activeTab, setActiveTab] = React.useState<string>('avlshunder');
    // const [pendingUpdates, setPendingUpdates] = React.useState<Map<string, any>>(new Map());

    function mapStatusToBoolean(status: string) {
        switch (status) {
            case "enabled":
                return true;
            case "disabled":
                return false;
            default:
                return false;
        }
    }

    function mapBooleanToStatus(status: boolean) {
        return status ? "enabled" : "disabled";
    }

    // Display column name with a checkbox to enable/disable
    function drawColumnEditor(column: any) {
        return (
            <div className={styles.column}>
                <Form.Check 
                    className={styles.switch + " " + (mapStatusToBoolean(column.STATUS) ? styles.switchenabled : styles.switchdisabled)}
                    type="switch"
                    id={column.ID}
                    label={t("breedingpageconfig.publiccolumns.titles." + column.COLUMN_IDENTIFIER)}
                    checked={mapStatusToBoolean(column.STATUS)}
                    onChange={() => {
                        setColumnStatus(column, !mapStatusToBoolean(column.STATUS));
                    }}
                />
            </div>
        );
    }

    // Display external column editor with editable fields
    // function drawExternalColumnEditor(column: any, index: number, sortedColumns: any[]) {
    //     const isEnabled = mapStatusToBoolean(column.STATUS);
    //     const isEditable = isEnabled;
        
    //     // Find the range of enabled columns for arrow button disabling
    //     // Only show arrows for enabled columns that have ID (have been saved to database)
    //     const enabledColumns = sortedColumns.filter(col => mapStatusToBoolean(col.STATUS) && col.ID);
    //     const enabledIndices = enabledColumns.map(col => sortedColumns.findIndex(c => c.PCO_ID === col.PCO_ID));
    //     const currentEnabledIndex = enabledIndices.indexOf(index);
    //     const hasColumnInfo = column.ID !== null;
    //     const canMoveUp = currentEnabledIndex > 0 && isEditable && hasColumnInfo;
    //     const canMoveDown = currentEnabledIndex < enabledIndices.length - 1 && isEditable && hasColumnInfo;
        
    //     return (
    //         <div className={styles.externalColumn}>
    //             <div className={styles.columnHeader}>
    //                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
    //                     <h6>{t("breedingpageconfig.publiccolumns.titles." + column.COLUMN_IDENTIFIER) || column.COLUMN_IDENTIFIER}</h6>
    //                     <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
    //                         {isEditable && column.ID !== null && (
    //                             <div className={styles.columnControls} style={{ display: 'flex', gap: '4px' }}>
    //                                 <button
    //                                     className={styles.orderButton}
    //                                     onClick={() => handleExternalColumnOrderChange(column, 'up', sortedColumns)}
    //                                     disabled={!canMoveUp}
    //                                     style={{ 
    //                                         padding: '4px 8px', 
    //                                         border: '1px solid #ccc', 
    //                                         borderRadius: '4px',
    //                                         background: 'white',
    //                                         cursor: !canMoveUp ? 'not-allowed' : 'pointer',
    //                                         opacity: !canMoveUp ? 0.5 : 1
    //                                     }}
    //                                 >
    //                                     ↑
    //                                 </button>
    //                                 <button
    //                                     className={styles.orderButton}
    //                                     onClick={() => handleExternalColumnOrderChange(column, 'down', sortedColumns)}
    //                                     disabled={!canMoveDown}
    //                                     style={{ 
    //                                         padding: '4px 8px', 
    //                                         border: '1px solid #ccc', 
    //                                         borderRadius: '4px',
    //                                         background: 'white',
    //                                         cursor: !canMoveDown ? 'not-allowed' : 'pointer',
    //                                         opacity: !canMoveDown ? 0.5 : 1
    //                                     }}
    //                                 >
    //                                     ↓
    //                                 </button>
    //                             </div>
    //                         )}
    //                         <Form.Check 
    //                             className={styles.switch + " " + (isEnabled ? styles.switchenabled : styles.switchdisabled)}
    //                             type="switch"
    //                             checked={isEnabled}
    //                             onChange={() => {
    //                                 setExternalColumnStatus(column, !isEnabled);
    //                             }}
    //                         />
    //                     </div>
    //                 </div>
    //             </div>
    //             <div className={styles.columnFields} style={{ opacity: isEditable ? 1 : 0.6 }}>
    //                 <div className={styles.fieldRow}>
    //                     <Form.Group className={styles.fieldGroup}>
    //                         <Form.Label className={styles.fieldLabel}>{t("breedingpageconfig.externalportal.fields.label")}</Form.Label>
    //                         <Form.Control
    //                             type="text"
    //                             size="sm"
    //                             value={column.LABEL || ''}
    //                             onChange={(e) => handleExternalColumnChange(column, 'LABEL', e.target.value)}
    //                             onBlur={() => handleExternalColumnBlur(column, 'LABEL')}
    //                         />
    //                     </Form.Group>
    //                     <Form.Group className={styles.fieldGroup}>
    //                         <Form.Label className={styles.fieldLabel}>{t("breedingpageconfig.externalportal.fields.columnGroup")}</Form.Label>
    //                         <Form.Control
    //                             type="text"
    //                             size="sm"
    //                             value={column.COLUMN_GROUP || ''}
    //                             onChange={(e) => handleExternalColumnChange(column, 'COLUMN_GROUP', e.target.value)}
    //                             onBlur={() => handleExternalColumnBlur(column, 'COLUMN_GROUP')}
    //                         />
    //                     </Form.Group>
    //                     <Form.Group className={styles.fieldGroup}>
    //                         <Form.Label className={styles.fieldLabel}>{t("breedingpageconfig.externalportal.fields.tooltip")}</Form.Label>
    //                         <Form.Control
    //                             type="text"
    //                             size="sm"
    //                             value={column.TOOLTIP || ''}
    //                             onChange={(e) => handleExternalColumnChange(column, 'TOOLTIP', e.target.value)}
    //                             onBlur={() => handleExternalColumnBlur(column, 'TOOLTIP')}
    //                         />
    //                     </Form.Group>
    //                     <Form.Group className={styles.fieldGroup}>
    //                         <Form.Check
    //                             className={styles.switch + " " + (column.DEFAULT_VISIBLE === 1 ? styles.switchenabled : styles.switchdisabled)}
    //                             type="switch"
    //                             label={t("breedingpageconfig.externalportal.fields.defaultVisible")}
    //                             checked={column.DEFAULT_VISIBLE === 1}
    //                             onChange={(e) => updateExternalColumn(column, 'DEFAULT_VISIBLE', e.target.checked ? 1 : 0)}
    //                         />
    //                     </Form.Group>
    //                 </div>
    //             </div>
    //         </div>
    //     );
    // }

    // Display breeding column editor with editable fields
    // function drawBreedingColumnEditor(column: any, index: number, sortedColumns: any[]) {
    //     const isEnabled = mapStatusToBoolean(column.STATUS);
    //     // Editable if enabled (even if PBCI_ID is null, we'll create it when needed)
    //     const isEditable = isEnabled;
    //     const minOrder = 3; // Minimum order for simulert-parring
        
    //     // Find the range of enabled columns for arrow button disabling
    //     // Only show arrows for enabled columns that have ID (have been saved to database)
    //     const enabledColumns = sortedColumns.filter(col => mapStatusToBoolean(col.STATUS) && col.ID);
    //     const enabledIndices = enabledColumns.map(col => sortedColumns.findIndex(c => c.PBC_ID === col.PBC_ID));
    //     const currentEnabledIndex = enabledIndices.indexOf(index);
    //     const hasColumnInfo = column.ID !== null;
    //     const canMoveUp = currentEnabledIndex > 0 && isEditable && hasColumnInfo;
    //     const canMoveDown = currentEnabledIndex < enabledIndices.length - 1 && isEditable && hasColumnInfo;
        
    //     return (
    //         <div className={styles.externalColumn}>
    //             <div className={styles.columnHeader}>
    //                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
    //                     <h6>{t("breedingpageconfig.publiccolumns.titles." + column.COLUMN_IDENTIFIER) || column.COLUMN_IDENTIFIER}</h6>
    //                     <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
    //                         {isEditable && column.ID !== null && (
    //                             <div className={styles.columnControls} style={{ display: 'flex', gap: '4px' }}>
    //                                 <button
    //                                     className={styles.orderButton}
    //                                     onClick={() => handleBreedingColumnOrderChange(column, 'up', sortedColumns, minOrder)}
    //                                     disabled={!canMoveUp}
    //                                     style={{ 
    //                                         padding: '4px 8px', 
    //                                         border: '1px solid #ccc', 
    //                                         borderRadius: '4px',
    //                                         background: 'white',
    //                                         cursor: !canMoveUp ? 'not-allowed' : 'pointer',
    //                                         opacity: !canMoveUp ? 0.5 : 1
    //                                     }}
    //                                 >
    //                                     ↑
    //                                 </button>
    //                                 <button
    //                                     className={styles.orderButton}
    //                                     onClick={() => handleBreedingColumnOrderChange(column, 'down', sortedColumns, minOrder)}
    //                                     disabled={!canMoveDown}
    //                                     style={{ 
    //                                         padding: '4px 8px', 
    //                                         border: '1px solid #ccc', 
    //                                         borderRadius: '4px',
    //                                         background: 'white',
    //                                         cursor: !canMoveDown ? 'not-allowed' : 'pointer',
    //                                         opacity: !canMoveDown ? 0.5 : 1
    //                                     }}
    //                                 >
    //                                     ↓
    //                                 </button>
    //                             </div>
    //                         )}
    //                         <Form.Check 
    //                             className={styles.switch + " " + (isEnabled ? styles.switchenabled : styles.switchdisabled)}
    //                             type="switch"
    //                             checked={isEnabled}
    //                             onChange={() => {
    //                                 setBreedingColumnStatus(column, !isEnabled);
    //                             }}
    //                         />
    //                     </div>
    //                 </div>
    //             </div>
    //             <div className={styles.columnFields} style={{ opacity: isEditable ? 1 : 0.6 }}>
    //                 <div className={styles.fieldRow}>
    //                     <Form.Group className={styles.fieldGroup}>
    //                         <Form.Label className={styles.fieldLabel}>{t("breedingpageconfig.externalportal.fields.label")}</Form.Label>
    //                         <Form.Control
    //                             type="text"
    //                             size="sm"
    //                             value={column.LABEL || ''}
    //                             onChange={(e) => handleBreedingColumnChange(column, 'LABEL', e.target.value)}
    //                             onBlur={() => handleBreedingColumnBlur(column, 'LABEL')}
    //                             disabled={!isEditable}
    //                         />
    //                     </Form.Group>
    //                     <Form.Group className={styles.fieldGroup}>
    //                         <Form.Label className={styles.fieldLabel}>{t("breedingpageconfig.externalportal.fields.columnGroup")}</Form.Label>
    //                         <Form.Control
    //                             type="text"
    //                             size="sm"
    //                             value={column.COLUMN_GROUP || ''}
    //                             onChange={(e) => handleBreedingColumnChange(column, 'COLUMN_GROUP', e.target.value)}
    //                             onBlur={() => handleBreedingColumnBlur(column, 'COLUMN_GROUP')}
    //                             disabled={!isEditable}
    //                         />
    //                     </Form.Group>
    //                     <Form.Group className={styles.fieldGroup}>
    //                         <Form.Label className={styles.fieldLabel}>{t("breedingpageconfig.externalportal.fields.tooltip")}</Form.Label>
    //                         <Form.Control
    //                             type="text"
    //                             size="sm"
    //                             value={column.TOOLTIP || ''}
    //                             onChange={(e) => handleBreedingColumnChange(column, 'TOOLTIP', e.target.value)}
    //                             onBlur={() => handleBreedingColumnBlur(column, 'TOOLTIP')}
    //                             disabled={!isEditable}
    //                         />
    //                     </Form.Group>
    //                     <Form.Group className={styles.fieldGroup}>
    //                         <Form.Check
    //                             className={styles.switch + " " + (column.DEFAULT_VISIBLE === 1 ? styles.switchenabled : styles.switchdisabled)}
    //                             type="switch"
    //                             label={t("breedingpageconfig.externalportal.fields.defaultVisible")}
    //                             checked={column.DEFAULT_VISIBLE === 1}
    //                             onChange={(e) => {
    //                                 const newValue = e.target.checked ? 1 : 0;
    //                                 // Update local state immediately
    //                                 setBreedingColumns((prevColumns: any) => 
    //                                     prevColumns?.map((col: any) => 
    //                                         col.PBC_ID === column.PBC_ID ? { ...col, DEFAULT_VISIBLE: newValue } : col
    //                                     )
    //                                 );
    //                                 // Then update in API
    //                                 updateBreedingColumn(column, 'DEFAULT_VISIBLE', newValue);
    //                             }}
    //                             disabled={!isEditable}
    //                         />
    //                     </Form.Group>
    //                 </div>
    //             </div>
    //         </div>
    //     );
    // }

    function setColumnStatus(column: any, status: boolean) {
        axios.single({
            method: 'put',
            url: "/api/dogs/breedingdogs/columns/" + column.ID,
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" },
            data: {
                STATUS: mapBooleanToStatus(status)
            }
        }).then((res: any) => {
            getColumns();
        }).catch((err: any) => {
            console.log(err);
        });
    }

    function getColumns() {
        axios.single({
            method: 'get',
            url: "/api/dogs/breedingdogs/columns/" + auth.selectedBreed,
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res: any) => {
            res.data = res.data.sort((a: any, b: any) => {
                return a.COLUMN_IDENTIFIER.localeCompare(b.COLUMN_IDENTIFIER);
            });
            setColumns(res.data);
        }).catch((err: any) => {
            console.log(err);
        });
    }

    // function getExternalColumns() {
    //     axios.single({
    //         method: 'get',
    //         url: `/api/dogs/columnsinfo/${auth.selectedBreed}/breeding_dogs`,
    //         responseType: 'json',
    //         headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
    //     }).then((res: any) => {
    //         // Normalize the API response - new structure has PCI_ prefixes
    //         if (Array.isArray(res.data)) {
    //             const normalizedColumns = res.data
    //                 .filter((item: any) => item.STATUS === 'enabled') // Only include enabled columns
    //                 .map((item: any) => {
    //                     const isEnabled = item.PCI_ID !== null;
    //                     let order = item.PCI_ORDER !== null ? item.PCI_ORDER : 0;
    //                     // Skip order 1 (reserved for "Name" column), automatically convert 1 to 2
    //                     if (order === 1) {
    //                         order = 2;
    //                     }
    //                     return {
    //                         PCO_ID: item.ID, // The PCO_ID (used for POST when creating)
    //                         ID: item.PCI_ID, // Use PCI_ID as the ID (null if not created yet)
    //                         COLUMN_IDENTIFIER: item.COLUMN_IDENTIFIER,
    //                         STATUS: isEnabled ? 'enabled' : 'disabled', // Enabled if PCI_ID exists
    //                         LABEL: item.PCI_LABEL || '',
    //                         COLUMN_GROUP: item.PCI_COLUMN_GROUP || '',
    //                         DEFAULT_VISIBLE: item.PCI_DEFAULT_VISIBLE !== null ? item.PCI_DEFAULT_VISIBLE : 0,
    //                         ORDER: order,
    //                         TOOLTIP: item.PCI_TOOLTIP || ''
    //                     };
    //                 });
    //             setExternalColumns(normalizedColumns);
    //         } else {
    //             setExternalColumns(res.data);
    //         }
    //     }).catch((err: any) => {
    //         console.log('External columns error:', err);
    //     });
    // }

    // function getBreedingColumns() {
    //     axios.single({
    //         method: 'get',
    //         url: `/api/dogs/breedingcolumnsinfo/${auth.selectedBreed}`,
    //         responseType: 'json',
    //         headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
    //     }).then((res: any) => {
    //         // Normalize the API response to remove PBC_ and PBCI_ prefixes for easier internal use
    //         const minOrder = 3; // Minimum order for simulert-parring
    //         const disabledOrder = 99; // Placeholder order for disabled columns
    //         const normalizedColumns = res.data.map((item: any) => {
    //             const isEnabled = item.PBC_STATUS === 'enabled';
    //             return {
    //                 PBC_ID: item.PBC_ID,
    //                 ID: item.PBCI_ID, // Use PBCI_ID for updates
    //                 COLUMN_IDENTIFIER: item.PBC_COLUMN_IDENTIFIER,
    //                 STATUS: item.PBC_STATUS, // This is the status that controls if column can be edited
    //                 LABEL: item.PBCI_LABEL || '',
    //                 COLUMN_GROUP: item.PBCI_COLUMN_GROUP || '',
    //                 DEFAULT_VISIBLE: item.PBCI_DEFAULT_VISIBLE !== null ? item.PBCI_DEFAULT_VISIBLE : 0,
    //                 ORDER: isEnabled && item.PBCI_ORDER !== null ? Math.max(item.PBCI_ORDER, minOrder) : (isEnabled ? minOrder : disabledOrder),
    //                 TOOLTIP: item.PBCI_TOOLTIP || ''
    //             };
    //         });
    //         setBreedingColumns(normalizedColumns);
    //     }).catch((err: any) => {
    //         console.log('Breeding columns error:', err);
    //     });
    // }

    // function updateExternalColumn(column: any, field: string, value: any) {
    //     const updatedColumn = { ...column, [field]: value };
        
    //     // Use PCI_ID for updates (ID field contains PCI_ID after normalization)
    //     axios.single({
    //         method: 'put',
    //         url: `/api/dogs/columnsinfo/${column.ID}`,
    //         responseType: 'json',
    //         headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" },
    //         data: {
    //             LABEL: updatedColumn.LABEL,
    //             COLUMN_GROUP: updatedColumn.COLUMN_GROUP,
    //             DEFAULT_VISIBLE: updatedColumn.DEFAULT_VISIBLE,
    //             ORDER: updatedColumn.ORDER,
    //             TOOLTIP: updatedColumn.TOOLTIP
    //         }
    //     }).then((res: any) => {
    //         // Update local state with server response, but preserve current values if response is missing fields
    //         setExternalColumns((prevColumns: any) => 
    //             prevColumns?.map((col: any) => {
    //                 if (col.ID === column.ID) {
    //                     // Merge response data with current local state to preserve user input
    //                     const responseData = res.data || res;
    //                     return {
    //                         ...col,
    //                         ID: responseData?.ID || responseData?.PCI_ID || col.ID,
    //                         LABEL: responseData?.LABEL || responseData?.PCI_LABEL || col.LABEL,
    //                         COLUMN_GROUP: responseData?.COLUMN_GROUP !== undefined && responseData?.COLUMN_GROUP !== null 
    //                             ? responseData.COLUMN_GROUP 
    //                             : (responseData?.PCI_COLUMN_GROUP !== undefined && responseData?.PCI_COLUMN_GROUP !== null
    //                                 ? responseData.PCI_COLUMN_GROUP
    //                                 : (col.COLUMN_GROUP !== undefined ? col.COLUMN_GROUP : '')),
    //                         DEFAULT_VISIBLE: responseData?.DEFAULT_VISIBLE !== undefined && responseData?.DEFAULT_VISIBLE !== null
    //                             ? responseData.DEFAULT_VISIBLE 
    //                             : (responseData?.PCI_DEFAULT_VISIBLE !== undefined && responseData?.PCI_DEFAULT_VISIBLE !== null
    //                                 ? responseData.PCI_DEFAULT_VISIBLE
    //                                 : (col.DEFAULT_VISIBLE !== undefined ? col.DEFAULT_VISIBLE : 0)),
    //                         ORDER: responseData?.ORDER !== undefined && responseData?.ORDER !== null
    //                             ? responseData.ORDER 
    //                             : (responseData?.PCI_ORDER !== undefined && responseData?.PCI_ORDER !== null
    //                                 ? responseData.PCI_ORDER
    //                                 : (col.ORDER !== undefined ? col.ORDER : 0)),
    //                         TOOLTIP: responseData?.TOOLTIP !== undefined && responseData?.TOOLTIP !== null
    //                             ? responseData.TOOLTIP 
    //                             : (responseData?.PCI_TOOLTIP !== undefined && responseData?.PCI_TOOLTIP !== null
    //                                 ? responseData.PCI_TOOLTIP
    //                                 : (col.TOOLTIP !== undefined ? col.TOOLTIP : ''))
    //                     };
    //                 }
    //                 return col;
    //             })
    //         );
    //     }).catch((err: any) => {
    //         console.log('External column update error:', err);
    //         getExternalColumns(); // Revert on error
    //     });
    // }

    // function setExternalColumnStatus(column: any, status: boolean) {
    //     // When enabling a column, create column info with POST
    //     if (status && !column.ID) {
    //         // Find the highest ORDER among enabled columns (excluding the one being enabled)
    //         const enabledColumns = externalColumns?.filter((col: any) => 
    //             col.PCO_ID !== column.PCO_ID && mapStatusToBoolean(col.STATUS) && col.ID !== null
    //         ) || [];
            
    //         const orders = enabledColumns
    //             .map((col: any) => {
    //                 const order = col.ORDER || 0;
    //                 return order !== 1 ? order : 2; // Skip order 1
    //             })
    //             .filter((order: number) => order > 1); // Filter out order 0 and 1
            
    //         // Calculate max order - ensure we skip order 1
    //         const maxOrder = orders.length > 0 
    //             ? Math.max(...orders) 
    //             : 2; // Start at 2 if no enabled columns exist (skip 0 and 1)
            
    //         const newOrder = maxOrder + 1; // Place at the end
            
    //         // Get default label from translations
    //         const translationKey = "breedingpageconfig.publiccolumns.titles." + column.COLUMN_IDENTIFIER;
    //         const translatedLabel = t(translationKey);
    //         const defaultLabel = translatedLabel && translatedLabel !== translationKey
    //             ? translatedLabel
    //             : column.COLUMN_IDENTIFIER;
            
    //         // POST to create column info
    //         axios.single({
    //             method: 'post',
    //             url: `/api/dogs/columnsinfo/${column.PCO_ID}`, // Use PCO_ID for POST
    //             responseType: 'json',
    //             headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" },
    //             data: {
    //                 LABEL: defaultLabel,
    //                 COLUMN_GROUP: '',
    //                 DEFAULT_VISIBLE: 0,
    //                 ORDER: newOrder,
    //                 TOOLTIP: ''
    //             }
    //         }).then((infoRes: any) => {
    //             // The API response format for POST: { lastRowid: '...', rowsAffected: 1 }
    //             const responseData = infoRes.data || infoRes;
    //             const pciId = responseData?.ID || responseData?.PCI_ID || responseData?.lastRowid || null;
                
    //             if (!pciId) {
    //                 console.error('External column info created but no PCI_ID returned:', responseData);
    //             }
                
    //             // Update local state immediately
    //             setExternalColumns((prevColumns: any) => 
    //                 prevColumns?.map((col: any) => {
    //                     if (col.PCO_ID === column.PCO_ID) {
    //                         return {
    //                             ...col,
    //                             STATUS: 'enabled',
    //                             ID: pciId, // This is the PCI_ID we'll use for future updates (PUT) and deletion (DELETE)
    //                             LABEL: defaultLabel,
    //                             COLUMN_GROUP: '',
    //                             DEFAULT_VISIBLE: 0,
    //                             ORDER: newOrder,
    //                             TOOLTIP: ''
    //                         };
    //                     }
    //                     return col;
    //                 })
    //             );
                
    //             // Refresh to ensure we have the latest data from server
    //             getExternalColumns();
    //         }).catch((err: any) => {
    //             console.error('External column info create error:', err);
    //             console.error('Error details:', err.response?.data || err.message);
    //             getExternalColumns(); // Still refresh even if error
    //         });
    //     } else if (!status && column.ID) {
    //         // When disabling, DELETE the column info
    //         axios.single({
    //             method: 'delete',
    //             url: `/api/dogs/columnsinfo/${column.ID}`, // Use PCI_ID for DELETE
    //             responseType: 'json',
    //             headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
    //         }).then((res: any) => {
    //             // Update local state immediately
    //             setExternalColumns((prevColumns: any) => 
    //                 prevColumns?.map((col: any) => {
    //                     if (col.PCO_ID === column.PCO_ID) {
    //                         return {
    //                             ...col,
    //                             STATUS: 'disabled',
    //                             ID: null, // Clear the PCI_ID
    //                             LABEL: '',
    //                             COLUMN_GROUP: '',
    //                             DEFAULT_VISIBLE: 0,
    //                             ORDER: 0,
    //                             TOOLTIP: ''
    //                         };
    //                     }
    //                     return col;
    //                 })
    //             );
                
    //             // Refresh to ensure we have the latest data from server
    //             getExternalColumns();
    //         }).catch((err: any) => {
    //             console.error('External column info delete error:', err);
    //             console.error('Error details:', err.response?.data || err.message);
    //             getExternalColumns(); // Still refresh even if error
    //         });
    //     }
    // }

    // function handleExternalColumnOrderChange(column: any, direction: 'up' | 'down', sortedColumns: any[]) {
    //     if (!column.ID) {
    //         return; // Can't change order without ID
    //     }

    //     const currentIndex = sortedColumns.findIndex(col => col.PCO_ID === column.PCO_ID);
    //     if (currentIndex === -1) return;

    //     // Find the next enabled column in the direction we want to move
    //     let targetColumn: any = null;
    //     let targetIndex = -1;
        
    //     if (direction === 'up') {
    //         // Look for the previous enabled column
    //         for (let i = currentIndex - 1; i >= 0; i--) {
    //             const col = sortedColumns[i];
    //             if (mapStatusToBoolean(col.STATUS) && col.ID) {
    //                 targetColumn = col;
    //                 targetIndex = i;
    //                 break;
    //             }
    //         }
    //     } else {
    //         // Look for the next enabled column
    //         for (let i = currentIndex + 1; i < sortedColumns.length; i++) {
    //             const col = sortedColumns[i];
    //             if (mapStatusToBoolean(col.STATUS) && col.ID) {
    //                 targetColumn = col;
    //                 targetIndex = i;
    //                 break;
    //             }
    //         }
    //     }

    //     if (!targetColumn) {
    //         return; // No column found to swap with
    //     }

    //     // Swap orders, but ensure we never use order 1 (reserved for "Name" column)
    //     const currentOrder = column.ORDER || 0;
    //     const targetOrder = targetColumn.ORDER || 0;

    //     // Ensure orders are never 1 (skip order 1)
    //     const adjustedCurrentOrder = currentOrder === 1 ? 2 : currentOrder;
    //     const adjustedTargetOrder = targetOrder === 1 ? 2 : targetOrder;

    //     // Update both columns
    //     const updatedCurrentColumn = { ...column, ORDER: adjustedTargetOrder };
    //     const updatedTargetColumn = { ...targetColumn, ORDER: adjustedCurrentOrder };

    //     // Update local state immediately
    //     setExternalColumns((prevColumns: any) => 
    //         prevColumns?.map((col: any) => {
    //             if (col.PCO_ID === column.PCO_ID) {
    //                 return updatedCurrentColumn;
    //             } else if (col.PCO_ID === targetColumn.PCO_ID) {
    //                 return updatedTargetColumn;
    //             }
    //             return col;
    //         })
    //     );

    //     // Update both columns in the API
    //     if (updatedCurrentColumn.ID) {
    //         updateExternalColumn(updatedCurrentColumn, 'ORDER', adjustedTargetOrder);
    //     }
    //     if (updatedTargetColumn.ID) {
    //         updateExternalColumn(updatedTargetColumn, 'ORDER', adjustedCurrentOrder);
    //     }
    // }

    // function handleExternalColumnChange(column: any, field: string, value: any) {
    //     // Only allow changes if column is enabled
    //     if (!mapStatusToBoolean(column.STATUS)) {
    //         return;
    //     }
        
    //     // Use PCO_ID for the key since ID can be null for disabled columns
    //     const key = `external_${column.PCO_ID}_${field}`;
    //     const originalValue = column[field] || '';
    //     const updatedColumn = { ...column, [field]: value };
        
        
    //     // Update local state immediately for UI responsiveness
    //     setExternalColumns((prevColumns: any) => 
    //         prevColumns?.map((col: any) => 
    //             col.PCO_ID === column.PCO_ID ? updatedColumn : col
    //         )
    //     );
        
    //     // Store pending update with original value for comparison
    //     setPendingUpdates(prev => {
    //         const newMap = new Map(prev);
    //         newMap.set(key, { column: updatedColumn, field, value, originalValue });
    //         return newMap;
    //     });
    // }

    // function handleExternalColumnBlur(column: any, field: string) {
    //     // Use PCO_ID for the key since ID can be null for disabled columns
    //     const key = `external_${column.PCO_ID}_${field}`;
    //     const pendingUpdate = pendingUpdates.get(key);
        
    //     if (pendingUpdate && pendingUpdate.value !== pendingUpdate.originalValue) {
    //         updateExternalColumn(pendingUpdate.column, field, pendingUpdate.value);
    //         setPendingUpdates(prev => {
    //             const newMap = new Map(prev);
    //             newMap.delete(key);
    //             return newMap;
    //         });
    //     }
    // }

    // function setBreedingColumnStatus(column: any, status: boolean) {
    //     const newStatus = mapBooleanToStatus(status);
        
    //     // When enabling a column, create column info with defaults
    //     if (status && !column.ID) {
    //         // Find the highest ORDER among enabled columns only (excluding the one being enabled)
    //         // Disabled columns have order 99, so we exclude those
    //         const enabledColumns = breedingColumns?.filter((col: any) => 
    //             col.PBC_ID !== column.PBC_ID && mapStatusToBoolean(col.STATUS)
    //         ) || [];
            
    //         const orders = enabledColumns
    //             .map((col: any) => {
    //                 const order = col.ORDER || 3;
    //                 return order !== 99 ? order : 0; // Filter out disabled placeholder (99)
    //             })
    //             .filter((order: number) => order > 0 && order !== 99); // Filter out invalid and disabled orders
            
    //         // Calculate max order - get the maximum order value from enabled columns
    //         // If no enabled columns exist, default to 2 so newOrder becomes 3
    //         const maxOrder = orders.length > 0 
    //             ? Math.max(...orders) 
    //             : 2; // Start at 2 so newOrder becomes 3 if no enabled columns exist
            
    //         const newOrder = maxOrder + 1; // Place at the end of all enabled columns - this will be saved to DB
            
    //         // Get default label from translations - always use translation value if available
    //         const translationKey = "breedingpageconfig.publiccolumns.titles." + column.COLUMN_IDENTIFIER;
    //         const translatedLabel = t(translationKey);
    //         // Use translation if it exists and is not the same as the key (meaning translation was found)
    //         // Otherwise fall back to column identifier
    //         const defaultLabel = translatedLabel && translatedLabel !== translationKey
    //             ? translatedLabel
    //             : column.COLUMN_IDENTIFIER;
            
    //         // Ensure we always have a label - this will be saved automatically
    //         if (!defaultLabel || defaultLabel.trim() === '') {
    //             console.warn(`No translation found for ${translationKey}, using identifier as fallback`);
    //         }
            
    //         // First update the status
    //         axios.single({
    //             method: 'put',
    //             url: `/api/dogs/breedingcolumns/${column.PBC_ID}`,
    //             responseType: 'json',
    //             headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" },
    //             data: {
    //                 STATUS: newStatus
    //             }
    //         }).then((statusRes: any) => {
    //             // Create or update column info
    //             // If we have PBCI_ID (column.ID), use PUT to update
    //             // If we don't have PBCI_ID, use POST to create with PBC_ID
    //             const columnInfoData = {
    //                 LABEL: defaultLabel,
    //                 COLUMN_GROUP: '',
    //                 DEFAULT_VISIBLE: 0,
    //                 ORDER: newOrder,
    //                 TOOLTIP: ''
    //             };

    //             // Check if we have PBCI_ID - if yes, use PUT; if no, use POST
    //             const hasPBCI_ID = column.ID !== null && column.ID !== undefined;
    //             const url = hasPBCI_ID 
    //                 ? `/api/dogs/breedingcolumnsinfo/${column.ID}` // PUT with PBCI_ID
    //                 : `/api/dogs/breedingcolumnsinfo/${column.PBC_ID}`; // POST with PBC_ID
    //             const method = hasPBCI_ID ? 'put' : 'post';

    //             axios.single({
    //                 method: method,
    //                 url: url,
    //                 responseType: 'json',
    //                 headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" },
    //                 data: columnInfoData
    //             }).then((infoRes: any) => {
    //                 // The API response format:
    //                 // POST returns: { lastRowid: '...', rowsAffected: 1 } - lastRowid is the PBCI_ID
    //                 // PUT returns: the updated record with ID/PBCI_ID fields
    //                 const responseData = infoRes.data || infoRes;
                    
    //                 // Extract PBCI_ID from response
    //                 // For POST, it's in lastRowid; for PUT, it's in ID or PBCI_ID
    //                 let pbcIId = responseData?.ID || responseData?.PBCI_ID || null;
                    
    //                 // If no ID found, check for lastRowid (POST response format)
    //                 if (!pbcIId && responseData?.lastRowid) {
    //                     pbcIId = responseData.lastRowid;
    //                 }
                    
    //                 // For PUT responses, get the saved values from response
    //                 // For POST responses (which only return lastRowid), use the values we sent
    //                 const savedLabel = responseData?.LABEL || responseData?.PBCI_LABEL || defaultLabel;
    //                 const savedOrder = responseData?.ORDER || responseData?.PBCI_ORDER || newOrder;
                    
    //                 if (!pbcIId) {
    //                     console.error('Breeding column info created/updated but no PBCI_ID returned:', responseData);
    //                 } else {
    //                     console.log('Breeding column info created/updated with PBCI_ID:', pbcIId);
    //                 }
                    
    //                 // Update local state immediately to show the new column info
    //                 // This ensures the arrows show up immediately and label is visible
    //                 setBreedingColumns((prevColumns: any) => 
    //                     prevColumns?.map((col: any) => {
    //                         if (col.PBC_ID === column.PBC_ID) {
    //                             return {
    //                                 ...col,
    //                                 STATUS: newStatus,
    //                                 ID: pbcIId, // This is the PBCI_ID we'll use for future updates (PUT requests)
    //                                 LABEL: savedLabel, // Label from translations.json - should be populated now
    //                                 COLUMN_GROUP: responseData?.COLUMN_GROUP || responseData?.PBCI_COLUMN_GROUP || '',
    //                                 DEFAULT_VISIBLE: responseData?.DEFAULT_VISIBLE !== undefined ? responseData.DEFAULT_VISIBLE : (responseData?.PBCI_DEFAULT_VISIBLE !== undefined ? responseData.PBCI_DEFAULT_VISIBLE : 0),
    //                                 ORDER: savedOrder, // Order is saved to DB
    //                                 TOOLTIP: responseData?.TOOLTIP || responseData?.PBCI_TOOLTIP || ''
    //                             };
    //                         }
    //                         return col;
    //                     })
    //                 );
                    
    //                 // Refresh to ensure we have the latest data from server and it's visible in external portal
    //                 // This will also update the data if the response structure was different
    //                 getBreedingColumns();
    //             }).catch((err: any) => {
    //                 console.error('Breeding column info create/update error:', err);
    //                 console.error('Error details:', err.response?.data || err.message);
    //                 console.error('Request URL (PUT then POST):', `/api/dogs/breedingcolumnsinfo/${column.PBC_ID}`);
    //                 console.error('Request data:', {
    //                     LABEL: defaultLabel,
    //                     COLUMN_GROUP: '',
    //                     DEFAULT_VISIBLE: 0,
    //                     ORDER: newOrder,
    //                     TOOLTIP: ''
    //                 });
    //                 getBreedingColumns(); // Still refresh even if error
    //             });
    //         }).catch((err: any) => {
    //             console.error('Breeding column status update error:', err);
    //             console.error('Error details:', err.response?.data || err.message);
    //         });
    //     } else {
    //         // Just update status if column already has info or is being disabled
    //         axios.single({
    //             method: 'put',
    //             url: `/api/dogs/breedingcolumns/${column.PBC_ID}`,
    //             responseType: 'json',
    //             headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" },
    //             data: {
    //                 STATUS: newStatus
    //             }
    //         }).then((res: any) => {
    //             getBreedingColumns();
    //         }).catch((err: any) => {
    //             console.log('Breeding column status update error:', err);
    //         });
    //     }
    // }

    // function updateBreedingColumn(column: any, field: string, value: any) {
    //     // Only allow updates if column is enabled
    //     if (!mapStatusToBoolean(column.STATUS)) {
    //         console.log('Cannot update disabled column');
    //         return;
    //     }
        
    //     // Get current column state to ensure we have latest values
    //     const currentColumn = breedingColumns?.find((col: any) => col.PBC_ID === column.PBC_ID) || column;
    //     const updatedColumn = { ...currentColumn, [field]: value };
        
    //     // Ensure LABEL is never empty - use column identifier as fallback
    //     const label = updatedColumn.LABEL || currentColumn.COLUMN_IDENTIFIER || '';
        
    //     // For updates, we must use PBCI_ID (not PBC_ID)
    //     // The ID field contains the PBCI_ID after the column info is created
    //     if (!currentColumn.ID) {
    //         console.error('Cannot update column info without PBCI_ID');
    //         return;
    //     }
        
    //     // Use PBCI_ID for updates
    //     const url = `/api/dogs/breedingcolumnsinfo/${currentColumn.ID}`;
        
    //     axios.single({
    //         method: 'put',
    //         url: url,
    //         responseType: 'json',
    //         headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" },
    //         data: {
    //             LABEL: label,
    //             COLUMN_GROUP: updatedColumn.COLUMN_GROUP || '',
    //             DEFAULT_VISIBLE: updatedColumn.DEFAULT_VISIBLE !== null && updatedColumn.DEFAULT_VISIBLE !== undefined ? updatedColumn.DEFAULT_VISIBLE : 0,
    //             ORDER: updatedColumn.ORDER || 3,
    //             TOOLTIP: updatedColumn.TOOLTIP || ''
    //         }
    //     }).then((res: any) => {
    //         // Update local state with server response, but preserve current values if response is missing fields
    //         setBreedingColumns((prevColumns: any) => 
    //             prevColumns?.map((col: any) => {
    //                 if (col.PBC_ID === currentColumn.PBC_ID) {
    //                     // Merge response data with current local state to preserve user input
    //                     const updatedCol = {
    //                         ...col,
    //                         ID: res.data?.ID || res.data?.PBCI_ID || col.ID || null,
    //                         // Only update if response has the value, otherwise keep current local state
    //                         LABEL: res.data?.LABEL || res.data?.PBCI_LABEL || col.LABEL || col.COLUMN_IDENTIFIER,
    //                         COLUMN_GROUP: res.data?.COLUMN_GROUP !== undefined && res.data?.COLUMN_GROUP !== null 
    //                             ? res.data.COLUMN_GROUP 
    //                             : (col.COLUMN_GROUP !== undefined ? col.COLUMN_GROUP : ''),
    //                         DEFAULT_VISIBLE: res.data?.DEFAULT_VISIBLE !== undefined && res.data?.DEFAULT_VISIBLE !== null
    //                             ? res.data.DEFAULT_VISIBLE 
    //                             : (col.DEFAULT_VISIBLE !== undefined ? col.DEFAULT_VISIBLE : 0),
    //                         ORDER: res.data?.ORDER !== undefined && res.data?.ORDER !== null
    //                             ? res.data.ORDER 
    //                             : (col.ORDER !== undefined ? col.ORDER : 3),
    //                         TOOLTIP: res.data?.TOOLTIP !== undefined && res.data?.TOOLTIP !== null
    //                             ? res.data.TOOLTIP 
    //                             : (col.TOOLTIP !== undefined ? col.TOOLTIP : '')
    //                     };
    //                     return updatedCol;
    //                 }
    //                 return col;
    //             })
    //         );
    //         // Don't refresh from API - we've merged the response with local state
    //     }).catch((err: any) => {
    //         console.log('Breeding column update error:', err);
    //         // Revert local state on error by refreshing from API
    //         getBreedingColumns();
    //     });
    // }

    // function handleBreedingColumnChange(column: any, field: string, value: any) {
    //     // Only allow changes if column is enabled
    //     if (!mapStatusToBoolean(column.STATUS)) {
    //         return;
    //     }
        
    //     // Use PBC_ID for the key since ID can be null for newly enabled columns
    //     const key = `breeding_${column.PBC_ID}_${field}`;
    //     const originalValue = column[field] || '';
    //     const updatedColumn = { ...column, [field]: value };
        
    //     // Update local state immediately for UI responsiveness
    //     setBreedingColumns((prevColumns: any) => 
    //         prevColumns?.map((col: any) => 
    //             col.PBC_ID === column.PBC_ID ? updatedColumn : col
    //         )
    //     );
        
    //     // Store pending update with original value for comparison
    //     setPendingUpdates(prev => {
    //         const newMap = new Map(prev);
    //         newMap.set(key, { column: updatedColumn, field, value, originalValue });
    //         return newMap;
    //     });
    // }

    // function handleBreedingColumnBlur(column: any, field: string) {
    //     // Use PBC_ID for the key since ID can be null for disabled columns
    //     const key = `breeding_${column.PBC_ID}_${field}`;
    //     const pendingUpdate = pendingUpdates.get(key);
        
    //     if (pendingUpdate) {
    //         // Get the current column state from local state (has the latest user input)
    //         const currentColumn = breedingColumns?.find((col: any) => col.PBC_ID === column.PBC_ID);
            
    //         if (!currentColumn) {
    //             // If column not found, just clear the pending update
    //             setPendingUpdates(prev => {
    //                 const newMap = new Map(prev);
    //                 newMap.delete(key);
    //                 return newMap;
    //             });
    //             return;
    //         }
            
    //         // Use current column state which has all the latest user input, including this field's value
    //         const columnToUpdate = currentColumn;
            
    //         // Check if value has changed (compare strings, handle empty values)
    //         const currentValue = String(pendingUpdate.value || '').trim();
    //         const originalValue = String(pendingUpdate.originalValue || '').trim();
            
    //         if (currentValue !== originalValue) {
    //             // Update the field using current column state (which has latest values)
    //             updateBreedingColumn(columnToUpdate, field, pendingUpdate.value);
    //             setPendingUpdates(prev => {
    //                 const newMap = new Map(prev);
    //                 newMap.delete(key);
    //                 return newMap;
    //             });
    //         } else {
    //             // Clear pending update if value hasn't changed
    //             setPendingUpdates(prev => {
    //                 const newMap = new Map(prev);
    //                 newMap.delete(key);
    //                 return newMap;
    //             });
    //         }
    //     }
    // }

    // function handleBreedingColumnOrderChange(column: any, direction: 'up' | 'down', sortedColumns: any[], minOrder: number) {
    //     if (!column.ID || !mapStatusToBoolean(column.STATUS)) {
    //         return; // Can't change order if disabled
    //     }

    //     const currentIndex = sortedColumns.findIndex(col => col.PBC_ID === column.PBC_ID);
    //     if (currentIndex === -1) return;

    //     // Find the next enabled column in the direction we want to move
    //     let targetColumn: any = null;
    //     let targetIndex = -1;
        
    //     if (direction === 'up') {
    //         // Look for the previous enabled column
    //         for (let i = currentIndex - 1; i >= 0; i--) {
    //             const col = sortedColumns[i];
    //             if (mapStatusToBoolean(col.STATUS) && col.ID) {
    //                 targetColumn = col;
    //                 targetIndex = i;
    //                 break;
    //             }
    //         }
    //     } else {
    //         // Look for the next enabled column
    //         for (let i = currentIndex + 1; i < sortedColumns.length; i++) {
    //             const col = sortedColumns[i];
    //             if (mapStatusToBoolean(col.STATUS) && col.ID) {
    //                 targetColumn = col;
    //                 targetIndex = i;
    //                 break;
    //             }
    //         }
    //     }

    //     if (!targetColumn) {
    //         return; // No enabled column found to swap with
    //     }

    //     // Swap orders
    //     const currentOrder = Math.max(column.ORDER || minOrder, minOrder);
    //     const targetOrder = Math.max(targetColumn.ORDER || minOrder, minOrder);

    //     // Update both columns
    //     const updatedCurrentColumn = { ...column, ORDER: targetOrder };
    //     const updatedTargetColumn = { ...targetColumn, ORDER: currentOrder };

    //     // Update local state immediately
    //     setBreedingColumns((prevColumns: any) => 
    //         prevColumns?.map((col: any) => {
    //             if (col.PBC_ID === column.PBC_ID) {
    //                 return updatedCurrentColumn;
    //             } else if (col.PBC_ID === targetColumn.PBC_ID) {
    //                 return updatedTargetColumn;
    //             }
    //             return col;
    //         })
    //     );

    //     // Update both columns in the API
    //     if (updatedCurrentColumn.ID) {
    //         updateBreedingColumn(updatedCurrentColumn, 'ORDER', targetOrder);
    //     }
    //     if (updatedTargetColumn.ID) {
    //         updateBreedingColumn(updatedTargetColumn, 'ORDER', currentOrder);
    //     }
    // }
    
    useEffect(() => {
        if (
            (
                auth.user?.userdata?.ROLE != "admin" &&
                auth.user?.userdata?.ROLE != "sysadmin" &&
                auth.user?.userdata?.ROLE != "user"
            ) ||
            general.getBreedAccess(auth.user, auth.selectedBreed) == "dogowner"
        ) {
            navigate("/");
        }
    }, [auth.user?.userdata?.ROLE, auth.selectedBreed]);

    useEffect(() => {
        if (auth.selectedBreed != undefined) {
            getColumns();
            // getExternalColumns();
            // getBreedingColumns();
        }
    }, [auth.selectedBreed]);

    return (
        <div className="maincontent">
            <div className={styles.breedingpageconfig}>
                <h1>{t("breedingpageconfig.title")}</h1>
                <hr/>

                <Container className={styles.container}>
                    <Row className={styles.row}>
                        <Col
                            sm="12"
                            md="6"
                            className={styles.col}
                        >
                            <Card
                                title={t("breedingpageconfig.fields.title")}
                            >
                                <div>
                                    <hr/>
                                    {columns && columns.map((column: any) => {
                                        return <div key={column.ID}>{drawColumnEditor(column)}</div>;
                                    })}
                                </div>
                            </Card>
                        </Col>
                    </Row>
                </Container>

                {/* <Container className={styles.container}>
                    <Row className={styles.row}>
                        <Col
                            sm="12"
                            className={styles.col}
                        >
                            <Card
                                title={t("breedingpageconfig.externalportal.title")}
                            >
                                <Tabs
                                    activeKey={activeTab}
                                    onSelect={(k) => setActiveTab(k || 'avlshunder')}
                                    className="mb-3"
                                >
                                    <Tab eventKey="avlshunder" title={t("breedingpageconfig.externalportal.tabs.avlshunder")}>
                                        <div className={styles.externalColumnsContainer}>
                                            {externalColumns && externalColumns.length > 0 ? (() => {
                                                // Sort columns: enabled columns first (by ORDER), then disabled columns (alphabetically)
                                                const sortedColumns = [...externalColumns].sort((a: any, b: any) => {
                                                    const aEnabled = mapStatusToBoolean(a.STATUS);
                                                    const bEnabled = mapStatusToBoolean(b.STATUS);
                                                    
                                                    // Enabled columns first, then disabled
                                                    if (aEnabled !== bEnabled) {
                                                        return aEnabled ? -1 : 1;
                                                    }
                                                    
                                                    // If both enabled, sort by order
                                                    if (aEnabled && bEnabled) {
                                                        const orderA = a.ORDER || 0;
                                                        const orderB = b.ORDER || 0;
                                                        return orderA - orderB;
                                                    }
                                                    
                                                    // If both disabled, sort alphabetically by translated name
                                                    const aTranslation = t("breedingpageconfig.publiccolumns.titles." + a.COLUMN_IDENTIFIER) || a.COLUMN_IDENTIFIER;
                                                    const bTranslation = t("breedingpageconfig.publiccolumns.titles." + b.COLUMN_IDENTIFIER) || b.COLUMN_IDENTIFIER;
                                                    return aTranslation.localeCompare(bTranslation, 'nb-NO', { sensitivity: 'base' });
                                                });
                                                return sortedColumns.map((column: any, index: number) => {
                                                    return <div key={column.PCO_ID}>{drawExternalColumnEditor(column, index, sortedColumns)}</div>;
                                                });
                                            })() : (
                                                <div>No external columns data available</div>
                                            )}
                                        </div>
                                    </Tab>
                                    <Tab eventKey="simulert-parring" title={t("breedingpageconfig.externalportal.tabs.simulert-parring")}>
                                        <div className={styles.externalColumnsContainer}>
                                            {breedingColumns && breedingColumns.length > 0 ? (() => {
                                                const minOrder = 3;
                                                const disabledOrder = 99;
                                                const sortedColumns = [...breedingColumns].sort((a: any, b: any) => {
                                                    const aEnabled = mapStatusToBoolean(a.STATUS);
                                                    const bEnabled = mapStatusToBoolean(b.STATUS);
                                                    
                                                    // Enabled columns first, then disabled
                                                    if (aEnabled !== bEnabled) {
                                                        return aEnabled ? -1 : 1;
                                                    }
                                                    
                                                    // If both enabled, sort by order
                                                    if (aEnabled && bEnabled) {
                                                        const orderA = Math.max(a.ORDER || minOrder, minOrder);
                                                        const orderB = Math.max(b.ORDER || minOrder, minOrder);
                                                        return orderA - orderB;
                                                    }
                                                    
                                                    // If both disabled, sort alphabetically by translated name
                                                    const aTranslation = t("breedingpageconfig.publiccolumns.titles." + a.COLUMN_IDENTIFIER) || a.COLUMN_IDENTIFIER;
                                                    const bTranslation = t("breedingpageconfig.publiccolumns.titles." + b.COLUMN_IDENTIFIER) || b.COLUMN_IDENTIFIER;
                                                    return aTranslation.localeCompare(bTranslation, 'nb-NO', { sensitivity: 'base' });
                                                });
                                                return sortedColumns.map((column: any, index: number) => {
                                                    return <div key={column.PBC_ID}>{drawBreedingColumnEditor(column, index, sortedColumns)}</div>;
                                                });
                                            })() : (
                                                <div>No breeding columns data available</div>
                                            )}
                                        </div>
                                    </Tab>
                                </Tabs>
                            </Card>
                        </Col>
                    </Row>
                </Container> */}
            </div>
        </div>
    );
}

class BreedingPageConfigProps {
    
}

export default BreedingPageConfig;